import { render, staticRenderFns } from "./WorkflowButtons.vue?vue&type=template&id=14384d95&"
import script from "./WorkflowButtons.vue?vue&type=script&lang=ts&"
export * from "./WorkflowButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports